import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { FC, memo } from 'react'
import { EventKindListToolbar } from './components/eventKindListToolbar/eventKindListToolbar'
import { EventKindListGrid } from './components/eventKindListGrid/eventKindListGrid'

export const ProjectDetailManagementEventKindList: FC = memo(() => {
  return (
    <div className="flex flex-col gap-2">
      <CrewErrorBoundary>
        <EventKindListToolbar />
      </CrewErrorBoundary>

      <CrewErrorBoundary>
        <EventKindListGrid />
      </CrewErrorBoundary>
    </div>
  )
})
